// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__31uXm","log":"ModalInventoryLogs_log__KqzXo","date":"ModalInventoryLogs_date__1PnrH","userName":"ModalInventoryLogs_userName__ZtmMb"};